<template>
  <form class="flex flex-col gap-2">
    <slot />
  </form>
</template>
